import { Component, OnInit } from '@angular/core';
import { LoggerService } from '../logger.service';
import { TranslatorService } from '../translator.service';
import { LoginService } from './login/login.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.page.html',
  styleUrls: ['./auth.page.scss'],
})
export class AuthPage implements OnInit {

  constructor(private logger: LoggerService, private loginService:LoginService, public translator:TranslatorService) { }
  public isMobile = false;
  public isARFeatureOn = false;
  ngOnInit() {
    this.isMobile = this.logger.getPlatorm() === "MOBILE";
    this.isARFeatureOn = this.loginService.isARFeatureOn;
  }

}
